import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { QuotationUpdateTicketComponent } from '../quotation-dialog/quotation-update-ticket/quotation-update-ticket.component';
import { SendRequestDialogComponent } from '../quotation-dialog/send-request-dialog/send-request-dialog.component';
import { registerLocaleData } from '@angular/common';
import localeMX from '@angular/common/locales/es';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { ModalSendEmailComponent } from '../../shared/modals/modal-send-email/modal-send-email.component';
import { Coverage } from '../../shared/models/quotation-model/catalogs/coverage.model';
import { DeadLine } from '../../shared/models/quotation-model/catalogs/dead-line.model';
import { QuotationComparative } from '../../shared/models/quotation-model/main/quotation-comparative.model';
import { QuotationEditFinalValues } from '../../shared/models/quotation-model/main/quotation-edit-final-values.model';
import { SelectQuotationOutData } from '../../shared/models/quotation-model/main/select-quotation-out-data.model.model';
import { SendMailTicketObj } from '../../shared/models/quotation-model/main/send-mail.model';
import { SendTicketObj } from '../../shared/models/quotation-model/main/send-ticket.model.model';
import { UpdateTicketObj } from '../../shared/models/quotation-model/main/update-ticket.model';
import { GeneralService } from '../../shared/services/general.service';
import { MigrationUtilityService } from '../../shared/services/migration-utility.service';
import { QuotationService } from '../../shared/services/quotation/quotation.service';
import { MatButtonModule } from '@angular/material/button';
import { GridComponent } from '../grid/grid.component';
import { QuotationFinancialValues } from '../../shared/models/quotation-model/main/quotation-financial-values.model';

registerLocaleData(localeMX, 'MX');

@Component({
  selector: 'app-comparative',
  templateUrl: './comparative.component.html',
  standalone: true,
  imports: [GridComponent, TranslateModule, MatButtonModule],
})
export class ComparativeComponent implements OnInit {
  @Output() resetQuotationEvent: EventEmitter<any> = new EventEmitter<any>();
  ticketId: string | null = '';
  isUpdate: number = 0;
  locale: string = localStorage.getItem('lang') == 'es' ? 'MXN' : 'USD';

  activeQuotationPDF: boolean = false;
  enableSend: boolean = false;
  hasQuotation: boolean = false;

  selectedDeadLines: DeadLine[] = [];
  selectedDeadline: DeadLine = {} as DeadLine;
  isOnLeaseLine: number = 0;

  selectedQuotationComparative: QuotationComparative = {} as QuotationComparative;
  selectedQuotationFinancialValue: QuotationEditFinalValues = {} as QuotationEditFinalValues;
  updateTicketObj: UpdateTicketObj = {} as UpdateTicketObj;
  selectQuotationOutData: SelectQuotationOutData = {} as SelectQuotationOutData;
  sendTicketObj: SendTicketObj = {} as SendTicketObj;
  sendMailTicketObj: SendMailTicketObj = {} as SendMailTicketObj;

  selectedCoverages: Coverage[] = [];
  @Input() quotationComparatives: any[] = [];
  columns: any[] = [];
  displayColumns: any[][] = [];
  @Input() comparativeData: any;
  @Input() quotationId: any;
  @Input() updateEnabled: any;
  @Input() Page: any;
  @Output() selectQuotationOutDataOut = new EventEmitter<SelectQuotationOutData>();

  constructor(
    private quotationService: QuotationService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private router: Router,
    private generalService: GeneralService,
    private migrationUtilityService: MigrationUtilityService,
  ) {}

  ngOnInit(): void {
    this.columns = [
      'deadlineId',
      'deadlineDescription',
      'managementCostAmount',
      'assetMonthlyPaymentAmount',
      'openingCommission',
      'damageInsuranceTotalAmount',
      'gpsPagoIva',
      'earlyRentAmount',
      'warrantyRentAmount',
      'paymentNoVat',
      'payment',
      //"residualValue", encabezado que no usa carvest
      'operationInitialDisbursement',
    ];
    this.displayColumns = [
      [this.translate.instant('Cobertura'), ''], //Cobertura
      [this.translate.instant('Plazo'), ''], //Plazo
      [this.translate.instant('GMDO'), '$'], //GMDO
      [this.translate.instant('Renta'), '$'], //Renta
      [this.translate.instant('Comision'), '$'], //openingCommission
      [this.translate.instant('Seguro de daños'), '$'], //Seguro de daños
      [this.translate.instant('Gps Mesual'), '$'], //Gps Mesual
      [this.translate.instant('Pagos anticipados'), '$'], //Pagos anticipados
      [this.translate.instant('Pagos en garantía'), '$'], //Pagos en garantía
      [this.translate.instant('Pago mensual sin IVA'), '$'], //Pago mensual sin IVA
      [this.translate.instant('Pago mensual con IVA'), '$'], //Pago mensual con IVA
      //[this.translate.instant("quotation.fieldNames.residualValue"),"$"],//Valor residual, no se usa en carvest
      [this.translate.instant('Desembolso inicial'), '$'], //Desembolso inicial
    ];
    this.ticketId = localStorage.getItem('ticketId');
    this.isUpdate = parseInt(localStorage.getItem('isUpdate') || '0');

    if (this.quotationId > 0) {
      this.hasQuotation = true;
    } else {
      this.quotationId = 0;
      this.ticketId = '';
    }

    this.selectedDeadLines = this.comparativeData.selectedDeadLines;
    this.selectedDeadline = this.comparativeData.selectedDeadline;
    this.selectedQuotationComparative = this.comparativeData.selectedQuotationComparative;
    this.selectedQuotationFinancialValue = this.comparativeData.selectedQuotationFinancialValue;
    this.selectedCoverages = this.comparativeData.selectedCoverages;
    this.quotationComparatives = this.comparativeData.quotationComparatives;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['comparativeData']) {
      this.selectedDeadLines = this.comparativeData.selectedDeadLines;
      this.selectedDeadline = this.comparativeData.selectedDeadline;
      this.selectedQuotationComparative = this.comparativeData.selectedQuotationComparative;
      this.selectedQuotationFinancialValue = this.comparativeData.selectedQuotationFinancialValue;
      this.selectedCoverages = this.comparativeData.selectedCoverages;
      this.quotationComparatives = this.comparativeData.quotationComparatives;

      if (this.selectedDeadline) {
        if (this.hasQuotation && this.updateEnabled && this.selectedDeadline.id != 0) {
          this.activeQuotationPDF = true;
          this.selectQuotationOutData.activequotationPDF = this.activeQuotationPDF;
          this.selectQuotationOutData.selectedDeadLine = this.selectedDeadline;
          this.selectQuotationOutDataOut.emit(this.selectQuotationOutData);
        }
      }
    }
  }

  async selectQuotation(event: QuotationComparative) {
    this.selectedDeadline = { description: 'na', id: event.id };
    this.activeQuotationPDF = true;
    this.selectQuotationOutData.activequotationPDF = this.activeQuotationPDF;
    this.selectQuotationOutData.selectedDeadLine = this.selectedDeadline;
    await this.sendQuotationComparative(event);
    this.selectQuotationOutDataOut.emit(this.selectQuotationOutData);
  }

  async sendQuotationComparative(event: QuotationComparative) {
    this.getFinancialValues();
    this.selectedQuotationComparative = event;
    const selectedQuotationFinancialValue: any = {};
    selectedQuotationFinancialValue.quotationId = this.selectedQuotationComparative.quotationId;
    selectedQuotationFinancialValue.accessoriesHook =
      this.selectedQuotationComparative.accessoriesHook;
    selectedQuotationFinancialValue.rateCost = this.selectedQuotationComparative.rateCost;
    selectedQuotationFinancialValue.rate = this.selectedQuotationComparative.rate;
    selectedQuotationFinancialValue.cat = this.selectedQuotationComparative.cat;
    selectedQuotationFinancialValue.openingCommissionAmount =
      this.selectedQuotationComparative.openingCommission;
    selectedQuotationFinancialValue.operationInitialDisbursement =
      this.selectedQuotationComparative.operationInitialDisbursement;
    selectedQuotationFinancialValue.interestRate = this.selectedQuotationComparative.interestRate;
    selectedQuotationFinancialValue.earlyWarrantyRent =
      this.selectedQuotationComparative.earlyWarrantyRent;
    selectedQuotationFinancialValue.vat = this.selectedQuotationComparative.vat;
    selectedQuotationFinancialValue.residualValue = this.selectedQuotationComparative.residualValue;
    selectedQuotationFinancialValue.payment = this.selectedQuotationComparative.payment;
    selectedQuotationFinancialValue.paymentNoVat = this.selectedQuotationComparative.paymentNoVat;
    selectedQuotationFinancialValue.paymentInsurance =
      this.selectedQuotationComparative.paymentInsurance;
    selectedQuotationFinancialValue.managementCostAmount =
      this.selectedQuotationComparative.managementCostAmount;
    selectedQuotationFinancialValue.cashAccessoriesAmount =
      this.selectedQuotationComparative.cashAccessoriesAmount;
    selectedQuotationFinancialValue.financialAccessoriesAmount =
      this.selectedQuotationComparative.financialAccessoriesAmount;
    selectedQuotationFinancialValue.udiAgencyInsuranceAmount =
      this.selectedQuotationComparative.udiAgencyInsuranceAmount;
    selectedQuotationFinancialValue.udiFinancialAmount =
      this.selectedQuotationComparative.udiFinancialAmount;
    selectedQuotationFinancialValue.udiDamagesInsuranceAmount =
      this.selectedQuotationComparative.udiDamagesInsuranceAmount;
    selectedQuotationFinancialValue.udiLifeInsurance =
      this.selectedQuotationComparative.udiLifeInsurance;
    selectedQuotationFinancialValue.annualInsuranceAmount =
      this.selectedQuotationComparative.annualInsuranceAmount;
    selectedQuotationFinancialValue.lifeInsuranceAmount =
      this.selectedQuotationComparative.lifeInsuranceAmount;
    selectedQuotationFinancialValue.damageInsuranceTotalAmount =
      this.selectedQuotationComparative.damageInsuranceTotalAmount;
    selectedQuotationFinancialValue.quotationIdFromWS =
      this.selectedQuotationComparative.quotationIdFromWS;
    selectedQuotationFinancialValue.assuranceQuotationId =
      this.selectedQuotationComparative.assuranceQuotationId;
    selectedQuotationFinancialValue.unemploymentInsuranceAmount =
      this.selectedQuotationComparative.unemploymentInsuranceAmount;
    selectedQuotationFinancialValue.insuranceTypesSumsAmount =
      this.selectedQuotationComparative.insuranceTypesSumsAmount;
    selectedQuotationFinancialValue.totalAmount = this.selectedQuotationComparative.financingAmount;
    selectedQuotationFinancialValue.deadlineDescription = event.term ?? 0; // term1
    selectedQuotationFinancialValue.coverageId = this.selectedQuotationComparative.coverageId;
    selectedQuotationFinancialValue.coverageIds = this.createComaString(this.selectedCoverages);
    selectedQuotationFinancialValue.srs = this.selectedQuotationComparative.srs;
    selectedQuotationFinancialValue.discountCard = this.selectedQuotationComparative.discountCard;
    selectedQuotationFinancialValue.deadlineIds = this.createComaString(this.selectedDeadLines);
    selectedQuotationFinancialValue.PaymentInsurance =
      this.selectedQuotationComparative.insurancePayment; // en el servios llega como insurancePayment pero al enviarse lo pide como PaymentInsurance, revisar despues para unificar
    selectedQuotationFinancialValue.gpsPago = this.selectedQuotationComparative.gpsPago;
    selectedQuotationFinancialValue.gpsTotal = this.selectedQuotationComparative.gpsTotal;
    selectedQuotationFinancialValue.gpsTipoPago = this.selectedQuotationComparative.gpsTipoPago;
    await firstValueFrom(
      this.quotationService.changeFinalValuesQuotation(selectedQuotationFinancialValue),
    );
    this.enableSend = true;
  }

  public createComaString(items: { id: number }[]): string {
    var deadLinesString = '';
    items.forEach((item) => {
      deadLinesString += item.id + ',';
    });
    const deadLineEditText = deadLinesString.slice(0, -1);
    return deadLineEditText;
  }

  public isSelectedAny(): boolean {
    return this.selectedDeadLines.some((e) => e.id === this.selectedDeadline.id);
  }

  public updateTicket() {
    this.updateTicketObj.quotationId = this.quotationId;
    this.updateTicketObj.ticketId = Number.parseInt(this.ticketId || '0');
    this.quotationService.updateTicket(this.updateTicketObj).subscribe(() => {
      this.dialog.open(QuotationUpdateTicketComponent, {
        width: '350px',
        panelClass: 'dialog-container-custom',
      });
    });
  }

  public sendEmail() {
    const dialogRef = this.dialog.open(ModalSendEmailComponent, {
      width: 'auto',
      height: 'auto',
      disableClose: true,
      autoFocus: false,
      data: {
        text: 'Envia la corizacion a tu correo electronico',
        titule: 'Envia cotización',
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
      }
    });
  }

  public sendTicketMoreRequest() {
    this.ticketId = localStorage.getItem('ticketId');
    this.sendMailTicketObj.quotationId = this.quotationId;
    this.sendMailTicketObj.externalEmail = '';
    this.sendMailTicketObj.ticketId = this.ticketId ? this.ticketId : '0';
    this.dialog.open(SendRequestDialogComponent, {
      width: '350px',
      data: { ticketObj: this.sendMailTicketObj },
      panelClass: 'dialog-container-custom',
    });
  }

  async sendTicket() {
    const userId = localStorage.getItem('userId');
    this.migrationUtilityService
      .changeQuotationStatus({
        quotationId: Number(this.quotationId),
        userId: Number(userId),
        newStatus: this.isOnLeaseLine === 0 ? 'PARA_ANALISIS' : 'PARA_NOTIFICACION',
        comment: this.isOnLeaseLine === 0 ? 'Cambio a Integración' : 'Cambio a Confirmación',
      })
      .subscribe((ress) => {
        this.generalService.viewSnacAlert(
          this.isOnLeaseLine === 0 ? 'Enviado a Integración' : 'Enviado a Confirmación',
          'normal',
          'Creado',
        );
        this.generalService.viewSnacAlert('Enviado a Integración', 'normal', 'Creado');
        this.generalService.goToUrl(['/workflow'], {
          statusSelected: 1,
        });
      });
  }

  async getFinancialValues() {
    const financialValues: QuotationFinancialValues = await firstValueFrom(
      this.quotationService.getQuotationFinancialValues(this.quotationId),
    );

    this.isOnLeaseLine = financialValues.isOnLeaseLine;
  }
}
